var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.99994C18 13.9673 13.9674 17.9999 9 17.9999C7.77343 17.9999 6.56036 17.7492 5.436 17.2645L3.35571 17.9665C3.16221 18.0314 2.94879 18.0012 2.78164 17.8835C2.61386 17.7665 2.51229 17.5769 2.50714 17.3725C2.50714 17.3725 2.45507 15.1771 2.45507 15.1778C0.880714 13.5096 0 11.3001 0 8.99994C0 4.03262 4.03264 0 9 0C13.9674 0 18 4.03262 18 8.99994V8.99994ZM7.65707 12.6674C7.4205 13.5822 7.96629 14.5195 8.88043 14.7644C9.79457 15.0093 10.7357 14.4706 10.9884 13.5597L12.0986 13.8573C12.4412 13.9493 12.7941 13.7455 12.8861 13.4028C12.978 13.0602 12.7742 12.7073 12.4316 12.6153L11.7797 12.4411L12.861 8.40466C13.4094 6.3591 12.2021 4.25312 10.1649 3.68933C10.1546 3.68612 10.1443 3.68355 10.1334 3.68098C8.0775 3.13005 5.96057 4.35211 5.40964 6.40796C5.08179 7.63259 4.60157 9.48787 4.35279 10.4509L3.73821 10.2863C3.39557 10.1944 3.04264 10.3981 2.95071 10.7408C2.85879 11.0834 3.06257 11.4364 3.40521 11.5283L7.65707 12.6674ZM10.5377 12.1081L5.59479 10.7839C5.84164 9.82665 6.32314 7.96688 6.65164 6.74096C7.01871 5.36975 8.42979 4.55526 9.801 4.92233C11.1716 5.29004 11.9867 6.7011 11.619 8.07166L10.5377 12.1081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a2d29b4e3b5425ad27e76739cf4d00c9.svg";
export { ForwardRef as ReactComponent };